import { connect, useSelector } from 'react-redux'

import {
  isAdhocEventSelector,
  isEventOwnerSelector
} from 'selectors/event_type'
import { eventTypeSelector } from 'root-api'
import { isDiagnosticsAvailableSelector } from 'selectors/diagnostics'
import { useRoutingForm } from 'components/use_routing_form'

import { RoutingFormPublisherToolbar } from './landing_page_publisher_toolbar'
import { BookingPageHeader } from './booking_page_header_feature'

const PublisherToolbar = ({ diagnosticsAvailable, isEventOwner, isAdhocEventType }) => {
  const { uuid } = useSelector(eventTypeSelector) || {}
  const routingForm = useRoutingForm()

  if (routingForm && routingForm?.policy?.update) return <RoutingFormPublisherToolbar />
  if (!uuid) return null
  if (diagnosticsAvailable || (isAdhocEventType && isEventOwner)) {
    return (
      <BookingPageHeader />
    )
  }

  return null
}

const mapStateToProps = (state) => ({
  diagnosticsAvailable: isDiagnosticsAvailableSelector(state),
  isEventOwner: isEventOwnerSelector(state),
  isAdhocEventType: isAdhocEventSelector(state)
})

export default connect(mapStateToProps)(PublisherToolbar)
